import { Skeleton } from 'antd';
import { Row, Column } from 'farmhub-ui-core';

const AssignerItemSkeleton = () => (
  <Row
    alignItems="center"
    justifyContent="space-between"
    styles={{ padding: '6px 0px' }}
    width="100%"
  >
    <Row styles={{ gap: 6 }} width="fit-content">
      <Skeleton.Avatar shape="circle" style={{ width: 32, height: 32 }} />
      <Column styles={{ gap: 2 }}>
        <Skeleton.Input size="small" style={{ width: 84 }} />
        <Skeleton.Input size="small" style={{ width: 48 }} />
      </Column>
    </Row>

    <Row styles={{ gap: 6 }} width="fit-content">
      <Skeleton.Input size="small" style={{ width: 48 }} />
    </Row>
  </Row>
);

export default AssignerItemSkeleton;
